import { render } from "./ViewFile.vue?vue&type=template&id=3c64be18&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"

import "./ViewFile.vue?vue&type=style&index=0&id=3c64be18&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c64be18"]])

export default __exports__